import { STATIC_URL, Pathname } from 'constants/data'

const arrowIconBlack = `${STATIC_URL}/filters/icon_arrow_black.svg`
const iconSearch = `${STATIC_URL}/filters/icon_search.svg`
const iconSearchNew = `${STATIC_URL}/filters/icon_search_new.svg`

const iconWebinars = `${STATIC_URL}/navbar/icon_webinars.svg`
const iconLibrary = `${STATIC_URL}/navbar/icon_library.svg`
const iconMain = `${STATIC_URL}/navbar/icon_main.svg`
const iconAiBolit = `${STATIC_URL}/navbar/icon_ai_bolit.svg`
const iconClinCase = `${STATIC_URL}/navbar/icon_clin_cases.svg`

const NavbarState = {
  NOT_OPENED: 'NOT_OPENED',
  PROFILE: 'PROFILE',
  SEARCH: 'SEARCH',
  NOTIFICATION: 'NOTIFICATION',
  HAMBURGER: 'HAMBURGER',
}

const lineHeight = '36px'
const lineHeightMobile = '44px'

const navBarItemsAll = [
  {
    link: `/${Pathname.WEBINAR}`,
    text: 'Вебинары',
    activeRoutes: [`/${Pathname.WEBINAR}/target`],
  },
  {
    link: `/${Pathname.LIBRARY}`,
    text: 'Библиотека',
    activeRoutes: [
      `/${Pathname.LIBRARY}/article`,
      `/${Pathname.LIBRARY}/video`,
      `/${Pathname.LIBRARY}/clinic`,
      `/${Pathname.LIBRARY}/podcast`,
      `/${Pathname.LIBRARY}/interactive`,
    ],
  },

  {
    link: `/${Pathname.AI_BOLIT}/landing`,
    text: 'AI Bolit',
  },

  {
    link: `/${Pathname.CLINICAL}`,
    text: 'Клинические случаи',
    noAuthLink: `/${Pathname.MEDPULSE}`,
  },

  {
    link: `/${Pathname.NMO_COURSE}`,
    text: 'Курсы НМО',
  },

  {
    link: `/${Pathname.CALCULATORS}/geriatric-status`,
    text: 'Шкалы',
    activeRoutes: [
      `/${Pathname.CALCULATORS}/geriatric-status`,
      `/${Pathname.CALCULATORS}/somatic-status`,
      `/${Pathname.CALCULATORS}/oabss`,
    ],
  },
]
const navBarItemsRestricted = [
  {
    link: `/${Pathname.NMO_COURSE}`,
    text: 'Курсы НМО',
  },

  {
    link: `/${Pathname.CALCULATORS}/geriatric-status`,
    text: 'Шкалы',
    activeRoutes: [
      `/${Pathname.CALCULATORS}/geriatric-status`,
      `/${Pathname.CALCULATORS}/somatic-status`,
      `/${Pathname.CALCULATORS}/oabss`,
    ],
  },
]
const navBarItemsBottom = [
  {
    link: `/${Pathname.WEBINAR}`,
    icon: iconWebinars,
    text: 'Вебинары',
    activeRoutes: [`/${Pathname.WEBINAR}/target`],
    imgWidth: 50,
    imgHeight: 38,
    marginLeft: 0,
  },
  {
    link: `/${Pathname.LIBRARY}`,
    icon: iconLibrary,
    text: 'Библиотека',
    activeRoutes: [
      `/${Pathname.LIBRARY}/article`,
      `/${Pathname.LIBRARY}/video`,
      `/${Pathname.LIBRARY}/clinic`,
      `/${Pathname.LIBRARY}/podcast`,
      `/${Pathname.LIBRARY}/interactive`,
      `/${Pathname.ARTICLE}/`,
    ],
    imgWidth: 58,
    imgHeight: 38,
    marginLeft: 18,
  },
  {
    link: `/${Pathname.MAIN}`,
    icon: iconMain,
    text: 'Главная страница',
    activeRoutes: [`/`],
    imgWidth: 40,
    imgHeight: 38,
    marginLeft: 19,
  },
  {
    link: `/${Pathname.AI_BOLIT}`,
    icon: iconAiBolit,
    text: 'AI Bolit',
    activeRoutes: [
      `/${Pathname.AI_BOLIT}`,
      `/${Pathname.AI_BOLIT}/history`,
      `/${Pathname.AI_BOLIT}/landing`,
    ],
    imgWidth: 34,
    imgHeight: 38,
    marginLeft: 25,
  },

  {
    link: `/${Pathname.CLINICAL}`,
    icon: iconClinCase,
    text: 'Клинические случаи',
    noAuthLink: `/${Pathname.MEDPULSE}`,
    activeRoutes: [`/${Pathname.MEDPULSE}`],
    imgWidth: 62,
    imgHeight: 38,
    marginLeft: 24,
  },
]

export {
  NavbarState,
  arrowIconBlack,
  iconSearch,
  lineHeight,
  lineHeightMobile,
  iconSearchNew,
  navBarItemsAll,
  navBarItemsRestricted,
  navBarItemsBottom,
}
